import React from "react"
import PropTypes from "prop-types"
import { graphql } from "gatsby"
import SanityImage from "gatsby-plugin-sanity-image"
import theme from "styles/theme"

const ImageChart = ({ title, subtitle, layout, image, alt }) => (
  <div css={{ textAlign: "center", [theme.mobile]: { textAlign: "left" } }}>
    <h3
      css={{
        ...theme.t5md,
        color: theme.midBlue,
      }}
    >
      {title}
    </h3>

    {subtitle && (
      <div
        css={{
          fontSize: 12,
          fontWeight: 400,
          color: theme.gray,
          marginTop: 4,
        }}
      >
        {subtitle}
      </div>
    )}

    <SanityImage
      {...image}
      width={layout === "full" ? 863 : 375}
      css={{ marginTop: 30 }}
      alt={alt}
    />
  </div>
)

export default ImageChart

ImageChart.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  image: PropTypes.shape({
    asset: PropTypes.shape({ _id: PropTypes.string.isRequired }).isRequired,
    hotspot: PropTypes.object,
    crop: PropTypes.object,
  }).isRequired,
  layout: PropTypes.oneOf(["full", "half"]),
  alt: PropTypes.string.isRequired,
}

export const query = graphql`
  fragment ImageChart on SanityImageChart {
    type: _type
    layout
    title
    subtitle
    image {
      ...Image
    }
    alt
  }
`
